<template>
  <div class="page-nav-toggle shadow left-aligned">
    <div class="question-wrapper">
      <div class="question">Have you already received your data from Tinder?</div>
      <div>
        <button
          v-bind:class="{'button-selected' : selectedButtonId === 1 }"
          @click="markSelection(1)"
        >How do I get my data?</button>
        <button
          v-bind:class="{'button-selected' : selectedButtonId === 2 }"
          @click="markSelection(2)"
        >Yes, give me my charts!</button>
      </div>
    </div>
    <img class="female-figure hide-on-mobile" src="@/assets/img/female-figure-sitting.svg">
    <img
      class="male-figure hide-on-mobile hide-on-tablet"
      src="@/assets/img/male-figure-sitting.svg"
    >
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedButtonId: null
    };
  },
  props: {
    defaultSelection: null
  },
  mounted() {
    this.selectedButtonId = this.defaultSelection
  },
  methods: {
    markSelection(id) {
      if (this.selectedButtonId !== id) {
        this.selectedButtonId = id;
        this.$emit("pageSwitch", id);
      }
    }
  }
};
</script>

<style scoped>
.page-nav-toggle {
  width: 85%;
  max-width: 1000px;
  position: relative;
  background-color: var(--light-text-color);
  height: 180px;
  border-radius: 10px;
  padding: 20px;
  margin: 20px 0;
  color: var(--dark-text-color);
  display: flex;
  align-items: center;
  justify-items: flex-start;
}

.question-wrapper .question {
  margin-bottom: 10px;
  font-weight: bold; 
}

img {
  position: absolute;
  height: auto;
  width: 80px;
}

.male-figure {
  display: none;
}

/* Large devices (desktops) */
@media (max-width: 575.8px) {
  .page-nav-toggle {
    height: 220px;
  }
}

/* Large devices (desktops) */
@media (min-width: 576px) {
  .female-figure {
    bottom: -20px;
    right: 10px;
  }

  .question-wrapper {
    width: 70%;
  }
}

@media (min-width: 900px) {
  .male-figure {
    top: -20px;
    right: 15%;
    display: block;
  }
}

button {
  height: 40px;
  border: 1px solid var(--tinder-blue-1);
  width: 190px;
  border-radius: 20px;
  background-color: var(--light-text-color);
  font-weight: bold;
  margin: 10px 20px 10px 0px;
  cursor: pointer;
}

.button-selected {
  background-color: var(--tinder-blue-1);
  color: var(--light-text-color);
}
</style>
